import React, { ReactNode } from 'react'

interface INoticeProps {
  children: ReactNode
}

export const Notice = (props: INoticeProps) => {
  return <div className="ly-notice">{props.children}</div>
}
